import { Component, Input} from '@angular/core';
import { NavController } from 'ionic-angular';

/**
   * Logger Factory
*/
@Component({
  selector: 'ute-empty-user-card',
  templateUrl: 'ute-empty-user-card.component.html'
})
export class UteEmptyUserCard {
  @Input() name: any;
  
  constructor(
    private navCtrl: NavController
  ){}

  addPatieint(){
    this.navCtrl.push('group-invitation-patient', {
      type: "assisted"
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/user/components/ute-empty-user-card/ute-empty-user-card.component.ts